module.exports = __webpack_public_path__ + "static/media/distributiveOr2.a2fbd4b4.JPG";